






















































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import authModel from "@/models/auth.model";
import EntityField from "@/layouts/components/EntityField.vue";


@Component({ components: { EntityField }})
export default class Login extends Vue {
  email = "";
  password = "";
  checkbox_remember_me = false;

  userEntityDescription: any[] = [];
  userEntity = {};

  async mounted() {
    this.userEntityDescription = await authModel.getUserDescription();
  }

  async login() {
    this.$vs.loading();
    try {
      await this.$store.dispatch("auth/login", { email: this.email, password: this.password });
    } catch (error) {
      if (error.message === "Account is pending approval") {
        error.message = "Sua conta ainda não foi aprovada";
      }
      this.$vs.notify({
        title: 'Erro',
        text: error.message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      });
      console.error(error);
    }
    this.$vs.loading.close();
  }

  onKeyDown(e: { keyCode: number; }){
   if(e.keyCode === 13){
     console.log('LOGIN')
     this.login()
   }
}


}
